import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  bookDifferenceColor: {
    color: "#D92D20",
  },
}));

export default styles;
